/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded FindInPage.
 * @export
 */
export const ICON_FIND_IN_PAGE = (
  <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M23.3332 10.3018V22.8552L18.8648 18.3752C19.6932 17.1152 20.0665 15.5285 19.6815 13.8252C19.1798 11.5735 17.2898 9.80016 15.0148 9.41516C11.0715 8.75016 7.69984 12.0518 8.21317 15.9602C8.5865 18.7018 10.9548 20.8602 13.7198 20.9885C15.0148 21.0585 16.2165 20.6852 17.2198 20.0318L22.3882 25.2002C21.9915 25.4918 21.5248 25.6668 20.9998 25.6668H6.98817C5.70484 25.6668 4.6665 24.6168 4.6665 23.3335L4.67817 4.66683C4.67817 3.3835 5.7165 2.3335 6.99984 2.3335H15.3648C15.9832 2.3335 16.5782 2.5785 17.0098 3.02183L22.6448 8.65683C23.0882 9.0885 23.3332 9.6835 23.3332 10.3018ZM13.9998 18.6668C12.0632 18.6668 10.4998 17.1035 10.4998 15.1668C10.4998 13.2302 12.0632 11.6668 13.9998 11.6668C15.9365 11.6668 17.4998 13.2302 17.4998 15.1668C17.4998 17.1035 15.9365 18.6668 13.9998 18.6668Z"
      fill="#707070"
      fillRule="evenodd"
    />
  </svg>
);
